export default __webpack_public_path__ + "static/media/O.fa628bb3.png";